import { fetchGet, fetchPost } from '../plugins/axios'
export const getCaseTypicalUserList = (params) => {
    return fetchGet('/cms-pdrs/open/getCaseTypicalUserList', params)
}
export const getDealCompany = (params) => {
    return fetchGet('/cms-pdrs/open/getDealCompany', params)
}
export const getCountUsers = (params) => {
    return fetchGet('/cms-pdrs/open/getCountUsers', params)
}
export const getDownloadNum = (params) => {
    return fetchGet('/cms-pdrs/open/getDownloadNum', params)
}
// add wechatImg
export const getServiceWXCode = (params) => {
    return fetchGet('/cms-pdrs/open/website/getServiceWXCode', params)
}
//累加官网下载量
export const setDownloadNum = (params) => {
    return fetchPost('/cms-pdrs/open/setDownloadNum', params)
}
//首页数据
export const getIndexData = (params) => {
    return fetchGet('/cms-pdrs/open/website/getBannerData', params)
}
//查询视频列表
export const getListVideos = (params) => {
    return fetchGet('/cms-pdrs/open/website/listVideos', params)
}
//视频浏览计数
export const getCounter = (params) => {
    return fetchPost('/cms-pdrs/open/website/triggerCounter', params)
}
//获取最新动态列表
export const listDynamic = (params) => {
    return fetchGet('/cms-pdrs/open/website/listDynamicTitles', params)
}
//获取最新动态详情
export const getDynamicDetail = (params) => {
    return fetchGet('/cms-pdrs/open/website/getDynamicDetail', params)
}

//获取云课堂详情
export const getCloudClassForShare = (params) => {
    return fetchGet('/cms-pdrs/open/classroom/getCloudClassForShare', params)
}

//查询典型用户行业列表
export const getTypicalUser = (params) => {
    return fetchGet('/cms-pdrs/open/website/listTypicalUserIndustries', params)
}
//查询典型用户LOGO
export const getTypicalLogos = (params) => {
    return fetchGet('/cms-pdrs/open/website/listTypicalUserLogos', {params})
}

// 查询平台对接各类型及其数量
export const getPlatTypeAndCount = (params) => {
    return fetchPost('/cms-pdrs/open/demand/getDemandCount', params)
}

// 查询平台对接列表
export const getPlatformList = (params) => {
    return fetchPost('/cms-pdrs/open/demand/getDemandList', params)
}

// 查询对接平台详情
export const getPlatformDetail = (params) => {
    return fetchPost('/cms-pdrs/open/demand/getDemandInfo', params)
}

//获取解决方案列表
export const getSolutionList = (params) => {
    return fetchGet('/cms-pdrs/open/website/listSolutions', params)
}

//获取解决方案详情
export const getSolutionDetail =(params) =>{
    return fetchGet('/cms-pdrs/open/website/getSolutionDetail',params)
}

//获取解决方案新版图片列表
export const getSolutionImg =(params) =>{
    return fetchGet('/cms-pdrs/open/website/listWebsiteSolutions',params)
}

//获取图片验证码
export const getVerificationCode =(params) =>{
    return fetchGet('/cms-pdrs/open/website/getVerificationCode',{params})
}
// 提交合作意向
export const registerCooperation = (params) => {
    return fetchPost('/cms-pdrs/open/website/registerCooperation', params)
}
// 提交投诉
export const submitComplaint = (params) => {
    return fetchPost('/cms-pdrs/open/website/submitComplaint', params)
}
// 提交投诉
export const submitRefuseShow = (params) => {
    return fetchPost('/cms-pdrs/open/website/submitRefuseShow', params)
}
//各省份销售订单
export const provinceOrder = (params) =>{
    return fetchPost('/cms-pdrs/open/website/retweetOmsProvinceQty',params)
}

//各平台销售额
export const platformSell = (params) =>{
    return fetchPost('/cms-pdrs/open/website/retweetOmsPlatformAmt',params)
}

//各物流公司包裹数
export const logisticsPack = (params) =>{
    return fetchPost('/cms-pdrs/open/website/retweetWmsLogisticDnqty',params)
}

//各省份销售额
export const provinceSell = (params) =>{
    return fetchPost('/cms-pdrs/open/website/retweetOmsProvinceAmt',params)
}

//各省份仓库分布
export const provinceWarehouse = (params) =>{
    return fetchPost('/cms-pdrs/open/website/retweetWmsProvinceWarehouseqty',params)
}

//获取当前时间
export const getTimes =(params) =>{
    return fetchGet('/cms-pdrs/open/website/getTime',params)
}

//标准产品信息
export const getStandardProduct =(params) =>{
    return fetchGet('/cms-pdrs/open/website/getAllStandardProduct',params)
}

//包年产品
export const getPackageProduct =(params) =>{
    return fetchGet('/cms-pdrs/open/website/getAllPackageProduct',params)
}

//官网优惠券
export const getPrizeCode = (params) =>{
    return fetchPost('/cms-pdrs/open/website/luckyDraw/getPrizeCode',params)
}

//优惠券验证码
export const sendVerificationCode = (params) =>{
    return fetchPost('/cms-pdrs/open/website/luckyDraw/sendVerificationCode',params)
}

//免密登录web吉客云
export const getFreeExperience = (params) =>{
    return fetchGet('/cms-pdrs/open/website/freeExperience',params)
}

// 人才招募列表
export const listRecruitment = (params) =>{
    return fetchGet('/cms-pdrs/open/website/listEmployments',params)
}

//查询云课堂标签
export const listClassTags = (params) =>{
    return fetchGet('/cms-pdrs/open/classroom/listClassTags',params)
}

//查询云课堂视频
export const listCloudClasses = (params) =>{
    return fetchGet('/cms-pdrs/open/classroom/listCloudClasses',params)
}

// 云课堂反馈提交 /cms-pdrs/open/classroom/submitFeedback
export const submitFeedback = (params) =>{
    return fetchPost('/cms-pdrs/open/classroom/submitFeedback',params)
}

// 云课堂浏览计数 /cms-pdrs/open/classroom/classTriggerCounter
export const classCount = (params) =>{
    return fetchPost('/cms-pdrs/open/classroom/classTriggerCounter',params)
}

export const postApi = (params) =>{
    return fetchPost('/cms-pdrs/open/website/retweet', params)
}



// WEBPACK FOOTER //
// ./src/api/index.js